var React = require('react');

function ArrowPagination (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-10, .cls-20 {\n        fill: none;\n        stroke: #0c2761;\n        stroke-width: 2px;\n      }\n\n      .cls-10 {\n        stroke-linejoin: round;\n      }\n    ")),React.createElement("g",{"id":"Icon_feather-arrow-right","data-name":"Icon feather-arrow-right","transform":"translate(1.414 0.707)","key":1},[React.createElement("path",{"id":"Path_144","data-name":"Path 144","className":"cls-10","d":"M28.833,18H7.5","transform":"translate(-7.5 -11.835)","key":0}),React.createElement("path",{"id":"Path_145","data-name":"Path 145","className":"cls-20","d":"M24.165,7.5,18,13.665l6.165,6.165","transform":"translate(-18 -7.5)","key":1})])]);
}

ArrowPagination.defaultProps = {"width":"22.747","height":"13.744","viewBox":"0 0 22.747 13.744"};

module.exports = ArrowPagination;

ArrowPagination.default = ArrowPagination;
